<template>
  <div class="hello" id="container">
    <!-- <h1 class="stage__title--sub">{{ heading }}</h1> -->
    <div class="stage_title--sub">
      <h1>{{ subheading }}</h1>
      <p>{{ body }}</p>
      <p>{{ footer }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { csbpApi } from '@/config/index.js';
export default {
  name: 'SolvedTicket',
  props: {
    siteName: String,
    ticketId: String,
    language: String,
    requesterId: String,
  },
  data: () => ({
    subheading: '',
    heading: '',
    body: '',
    footer: '',
  }),

  async mounted() {
    window.addEventListener('resize', this.resizeWindow);
    this.messageLanguage();
    this.resizeWindow();
    await this.solveTicket();
  },
  methods: {
    resizeWindow() {
      let newHeight = document.getElementById('container') && document.getElementById('container').scrollHeight ? `${Math.max(document.getElementById('container').scrollHeight, 250)}px` : '600px';
      if (window.parent) {
        window.parent.postMessage({ height: newHeight }, '*');
      }
    },
    messageLanguage() {
      let message = {
        'en-us': {
          heading: 'Thanks!',
          subheading: this.siteName ? `Thank you for using ${this.siteName} Customer Support` : `Thank you for using Customer Support`,
          body: `Your ticket ${this.ticketId ? this.ticketId : ''} is now solved`,
          footer: 'If you need any further assistance, please contact us',
        },
        fr: {
          heading: 'Merci!',
          subheading: this.siteName ? `Merci d'utiliser le ${this.siteName} service client` : `Merci d'utiliser notre service client`,
          body: `Votre ticket ${this.ticketId ? this.ticketId : ''} est maintenant résolu`,
          footer: "Si vous avez besoin d'une assistance supplémentaire, veuillez nous contacter",
        },
        it: {
          heading: 'Grazie!',
          subheading: this.siteName ? `Grazie per aver utilizzato ${this.siteName} Assistenza clienti` : `Grazie per aver utilizzato la nostra Assistenza clienti`,
          body: `Il tuo ticket ${this.ticketId ? this.ticketId : ''} è ora risolto`,
          footer: 'Se hai bisogno di ulteriore assistenza, contattaci',
        },
        ja: {
          heading: 'ありがとう！',
          subheading: this.siteName ? `${this.siteName}カスタマーサポートをご利用いただきありがとうございます` : `カスタマーサポートをご利用いただきありがとうございます`,
          body: `チケット${this.ticketId ? this.ticketId : ''}が解決されました`,
          footer: 'さらにサポートが必要な場合は、お問い合わせください',
        },
        pt: {
          heading: 'Obrigado! ',
          subheading: this.siteName ? `Obrigado por usar o Suporte ao Cliente do ${this.siteName}` : `Obrigado por usar nosso Suporte ao Cliente`,
          body: `Seu tíquete ${this.ticketId ? this.ticketId : ''} agora está resolvido `,
          footer: 'Se precisar de mais ajuda, entre em contato conosco',
        },
        es: {
          heading: '¡Gracias! ',
          subheading: this.siteName ? `Gracias por utilizar ${this.siteName} Atención al cliente` : `Gracias por utilizar nuestro servicio de atención al cliente`,
          body: `Su ticket ${this.ticketId ? this.ticketId : ''} ahora está resuelto`,
          footer: 'Si necesita más ayuda, contáctenos',
        },
      };
      let resultMessage = message[this.language];
      if (!resultMessage) {
        resultMessage = message['en-us'];
      }
      this.heading = resultMessage.heading;
      this.subheading = resultMessage.subheading;
      this.body = resultMessage.body;
      this.footer = resultMessage.footer;
      return;
    },

    async solveTicket() {
      if (!this.ticketId || !this.requesterId) {
        console.error('no ticket id or code');
        return;
      }
      try {
        let response = await axios.post(
          `${csbpApi}/zendesk/ticket/${this.ticketId}/solve`,
          {
            requesterId: this.requesterId,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        return response;
      } catch (error) {
        console.error(error);
        return;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background-color: #f7f4f4;
}
.stage__title {
  font-size: 23px;
  font-family: 'Lato', sans-serif;
  font-weight: 900 !important;
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;
  color: #2b2b2b;
}
.stage_title--sub {
  font-size: 18px;
  font-family: 'Lato', sans-serif;
  padding: 0 1rem 0;
  font-weight: 400;
  margin: 0;
  margin-bottom: 2.9rem;
  color: #8c8c8c;
  letter-spacing: 0.03rem;
}
.stage_title--sub h1 {
  margin-bottom: 0.67em;
}
@media (min-width: 641px) {
  .stage__title {
    font-size: 42px;
  }
}

@media (min-width: 832px) {
  .stage__title {
    padding-top: 0;
    margin-top: -0.7rem;
  }
  .stage_title--sub {
    padding-top: 15rem;
    padding-bottom: 1.25rem;
    font-size: 18px;
  }
}
/* h3 {
  margin: 40px 0 0;
} */
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
